<template>
  <el-menu class="el-menu-vertical-demo" :default-active="index" @select="handleSelect">
    <el-menu-item-group v-for="menu in menus" :title="menu.group.name" :key="menu.group.id">
      <el-menu-item v-for="m in menu.menus" :key="m.id" :index="m.id">
        <div v-if="m.redirect">
          <a href="#">{{ m.name }}</a>
        </div>
        <div v-else>
          {{ m.name }}
        </div>
      </el-menu-item>
    </el-menu-item-group>
  </el-menu>
</template>

<script>
export default {
  name: "SideBar",
  props: {
    index: String,
    menus: Array
  },
  computed: {
    menusMap: function() {
      let hashmenu = {};
      this.menus.forEach(menu => {
        menu.menus.forEach(m => {
          hashmenu[m.id] = m
        });
      });
      return hashmenu;
    }
  },
  methods: {
    handleSelect: function(index) {
      if (this.menusMap[index].redirect) {
        window.open(this.menusMap[index].redirect);
      } else {
        this.$emit('update:index', index)
      }
    }
  }
};
</script>
